/* some useful constants for camera functionality */

// CameraStream options
export const PREVIEW_CONTAINER_WIDTH = 200
export const PREVIEW_WIDTH = 700
export const IDEAL_STREAM_WIDTH_FRONT = 900
export const IDEAL_STREAM_WIDTH_BACK = 2000
